'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.unlocalize = exports.MessageType = exports.MessageStatus = exports.MessagePriority = exports.MessageDesign = void 0;
var tslib_1 = require("tslib");
/**
 * All available design types for messages
 */
var MessageDesign;
(function (MessageDesign) {
    MessageDesign[MessageDesign["GENERAL_NOTIFICATION"] = 0] = "GENERAL_NOTIFICATION";
    MessageDesign[MessageDesign["FREE_SPINS"] = 1] = "FREE_SPINS";
    MessageDesign[MessageDesign["RELOAD_BONUS"] = 2] = "RELOAD_BONUS";
    MessageDesign[MessageDesign["FREE_MONEY_BONUS"] = 3] = "FREE_MONEY_BONUS";
    MessageDesign[MessageDesign["HAPPY_HOURS"] = 4] = "HAPPY_HOURS";
    MessageDesign[MessageDesign["DOUBLE_RELOAD"] = 5] = "DOUBLE_RELOAD";
    MessageDesign[MessageDesign["FIXED_RELOAD"] = 6] = "FIXED_RELOAD";
    MessageDesign[MessageDesign["FESTIVAL"] = 7] = "FESTIVAL";
    MessageDesign[MessageDesign["FREE_FALL_CHALLENGE"] = 8] = "FREE_FALL_CHALLENGE";
    MessageDesign[MessageDesign["DEPOSIT_AND_FREE_SPINS"] = 9] = "DEPOSIT_AND_FREE_SPINS";
    MessageDesign[MessageDesign["NEW_GAME"] = 10] = "NEW_GAME";
    MessageDesign[MessageDesign["SURPRISE_BUNNY"] = 11] = "SURPRISE_BUNNY";
    MessageDesign[MessageDesign["EASTER_EGG"] = 12] = "EASTER_EGG";
    MessageDesign[MessageDesign["SUMMER"] = 13] = "SUMMER";
    MessageDesign[MessageDesign["BONUS_METRE"] = 14] = "BONUS_METRE";
    MessageDesign[MessageDesign["REGISTRATION"] = 15] = "REGISTRATION";
    MessageDesign[MessageDesign["HALLOWEEN"] = 16] = "HALLOWEEN";
    MessageDesign[MessageDesign["CHRISTMAS"] = 17] = "CHRISTMAS";
    MessageDesign[MessageDesign["REWARD"] = 18] = "REWARD";
    MessageDesign[MessageDesign["PERSONAL_NOTE"] = 19] = "PERSONAL_NOTE";
    MessageDesign[MessageDesign["CASINO"] = 20] = "CASINO";
    MessageDesign[MessageDesign["SPORTSBOOK"] = 21] = "SPORTSBOOK";
    MessageDesign[MessageDesign["DEPOSIT"] = 22] = "DEPOSIT";
    MessageDesign[MessageDesign["PLAY"] = 23] = "PLAY";
    MessageDesign[MessageDesign["SUCCESS"] = 24] = "SUCCESS";
    MessageDesign[MessageDesign["GENERIC"] = 25] = "GENERIC";
})(MessageDesign = exports.MessageDesign || (exports.MessageDesign = {}));
/**
 * Represents how important the message is. The lower, the more important.
 */
var MessagePriority;
(function (MessagePriority) {
    MessagePriority[MessagePriority["PROMOTION"] = 0] = "PROMOTION";
    MessagePriority[MessagePriority["POP_OPEN"] = 1] = "POP_OPEN";
    MessagePriority[MessagePriority["IMPORTANT"] = 2] = "IMPORTANT";
    MessagePriority[MessagePriority["BIG_PROMOTION"] = 3] = "BIG_PROMOTION";
    MessagePriority[MessagePriority["LOW_PRIORITY"] = 4] = "LOW_PRIORITY";
})(MessagePriority = exports.MessagePriority || (exports.MessagePriority = {}));
/**
 * Possible message statuses. The 'NEW' status is set internally for
 * consistency purposes when a message object is created. A new message
 * coming from the backend won't have any status at all.
 */
var MessageStatus;
(function (MessageStatus) {
    MessageStatus["READ"] = "R";
    MessageStatus["DELETED"] = "D";
    MessageStatus["CANCELLED"] = "C";
    MessageStatus["NEW"] = "N";
})(MessageStatus = exports.MessageStatus || (exports.MessageStatus = {}));
/**
 * Available message types. The most important are CAMPAIGN and NOTIFICATION.
 */
var MessageType;
(function (MessageType) {
    MessageType[MessageType["CAMPAIGN"] = 0] = "CAMPAIGN";
    MessageType[MessageType["AD_HOC"] = 1] = "AD_HOC";
    MessageType[MessageType["ALERTS"] = 2] = "ALERTS";
    MessageType[MessageType["AFFILIATE"] = 3] = "AFFILIATE";
    MessageType[MessageType["BONUS"] = 4] = "BONUS";
    MessageType[MessageType["VIP"] = 5] = "VIP";
    MessageType[MessageType["NOTIFICATION"] = 6] = "NOTIFICATION";
    MessageType[MessageType["PLAY_SAFE"] = 7] = "PLAY_SAFE";
})(MessageType = exports.MessageType || (exports.MessageType = {}));
function unlocalize(msg, lang) {
    return tslib_1.__assign(tslib_1.__assign({}, msg), { subject: msg.subject ? msg.subject[lang] : undefined, body: msg.body ? msg.body[lang] : undefined, image: msg.image ? msg.image[lang] : undefined, link: msg.link ? msg.link[lang] : undefined, link2: msg.link2 ? msg.link2[lang] : undefined, tnc: msg.tnc ? msg.tnc[lang] : undefined, video: msg.video ? msg.video[lang] : undefined, status: msg.status || MessageStatus.NEW });
}
exports.unlocalize = unlocalize;
